import PouchDB from "pouchdb";
import { EventBus } from '@/event-bus.js';

/**
 * Database class
 */
export default class Database {


   
  /**
   * constructor
   * @param {string} name - The name of the database
   */
  constructor(name) {
      // Set local DB
      this.fullName = name;
      this.url = 'https://inspect-couch.gloo.io/inspect-';
      this.local_db = new PouchDB(this.fullName); 
    }

    replicate() {

        var ref = this

        // do one way, one-off sync from the server until completion
        this.local_db.replicate.from(this.url+''+this.fullName)
        .on('change', function (info) {
        // handle change
        console.log("change", info)
        }).on('paused', function (err) {
        // replication paused (e.g. replication up to date, user went offline)
        }).on('active', function () {
        // replicate resumed (e.g. new changes replicating, user went back online)
        }).on('denied', function (err) {
        // a document failed to replicate (e.g. due to permissions)
        }).on('complete', function (info) {
            console.log("complete", info, this)
            EventBus.$emit('replicate:complete', { name: ref.fullName })
            //ref.db_callback("replicate:complete", {})
            ref.sync()
        // handle complete
        }).on('error', function (err) {
        // handle error
        });        
        
    }
    
    sync() {

        var opts = { live: true, retry: true };

        this.local_db.sync(this.url+''+this.fullName, opts)
        .on('change', function(d) {
          console.log("sync___change", d)
        })
        .on('paused', function(d) {
          
        })
        .on('error', function(d) {
          
        });       
    }


    async getAllInsection() {
        var dbPrefix = 'inspection/';
        var idPrefix = dbPrefix
    
        try {
            var entries =   this.local_db.allDocs({
                include_docs: true,
                attachments: false,
                  startkey: idPrefix,
                  endkey: idPrefix + '\uffff'
              })
            return entries
        }
        catch (err) {
            return err
        }   
    }

/**
 * getter and setter for verbose name of the database
 */
  get verboseName() {
    return this._verboseName;
  }
  set verboseName(val) {
    this._verboseName = val;
  }

}
